export const WHATSAPP_STATUS_QUERY = 'whatsappStatusQuery';
